import React from "react";
export default function ShipParam({ field, ship, title }) {
  if (ship?.[field]) {
    return (
      <div className="row py-2">
        <div className="col-4 text-dark-50">{title}</div>
        <div className="col">{ship[field]}</div>
      </div>
    );
  }
  return null;
}
